import React from 'react'
import classes from './privacy_policy.module.css'

const styles = {
  heading: { marginTop: '1.8rem', marginBottom: '0.4rem', fontSize: '1.2rem' },
  title: { fontSize: '1.7rem', marginBottom: '0.5rem' },
  meta: { color: '#555', fontSize: '0.95rem', lineHeight: 1.7, marginBottom: '1.5rem' },
  p: { lineHeight: 1.7, margin: '0.6rem 0' },
  list: { lineHeight: 1.7, paddingLeft: '1.4rem' },
  code: { background: '#f2f2f2', padding: '1px 5px', borderRadius: '4px' }
}

export default function PrivacyPolicy () {
  return (
    <>
      <div className={classes.top_container}></div>

      <div className={classes.content}>
        <h1 style={styles.title}>Privacy Policy</h1>

        <p style={styles.p}>
          <strong>Android app:</strong> DIY Live Wallpaper Maker Photo (formerly &quot;PaletteWall DIY Live Wallpaper&quot;)<br />
          <strong>Google Play package name:</strong> com.palettex.palettewall<br />
          <strong>iOS app:</strong> PaletteX<br />
          <strong>App Store bundle ID:</strong> com.palettex.wallpaper<br />
          <strong>Contact:</strong> <a href="mailto:palettexca@gmail.com">palettexca@gmail.com</a><br />
          <strong>Effective date:</strong> 2026-09-06
        </p>

        <p style={styles.p}>
          This Privacy Policy explains how Levi Liao (operating as &quot;PaletteX&quot;, hereby the
          &quot;Service Provider&quot;) collects, uses, and shares information in the mobile applications
          <strong> DIY Live Wallpaper Maker Photo</strong> (Google Play package
          {' '}com.palettex.palettewall, available on Google Play) and
          <strong> PaletteX</strong> (bundle ID com.palettex.wallpaper, available on the Apple App Store)
          (each and collectively, the &quot;Application&quot;).
          The Application is provided as a free service and is intended for use &quot;AS IS&quot;.
          By using the Application, you consent to the practices described in this policy.
        </p>

        <h2 style={styles.heading}>Information Collection and Use</h2>
        <p style={styles.p}>
          The Application collects information when you download and use it. This information may include:
        </p>
        <ul style={styles.list}>
          <li>Your device&apos;s Internet Protocol (IP) address</li>
          <li>The features and screens of the Application you use, and the time and date of use</li>
          <li>The amount of time spent in the Application</li>
          <li>Your device model, manufacturer, and operating system version</li>
          <li>Approximate location at the country level (derived from your IP address) for analytics</li>
        </ul>
        <p style={styles.p}>
          The Application does <strong>not</strong> gather precise GPS location data from your mobile device.
        </p>

        <h2 style={styles.heading}>Your Photos</h2>
        <p style={styles.p}>
          When you create a DIY live wallpaper, you select photos from your device. These photos are used
          <strong> only on your device</strong> to render your wallpaper and are stored locally on your device.
          The Service Provider does <strong>not</strong> upload, transmit, or store your personal photos on any server.
        </p>
        <p style={styles.p}>
          On iOS, the Application asks for permission to save your finished wallpaper (as a Live Photo) to your
          photo library. This access is used only to save the wallpapers you create and, if you choose, to verify
          a saved wallpaper; the Application does not scan or collect the contents of your photo library.
        </p>

        <h2 style={styles.heading}>Advertising &amp; Tracking (App Tracking Transparency on iOS)</h2>
        <p style={styles.p}>
          The Application shows ads served by Google AdMob. On iOS, before ads are first requested, the system
          App Tracking Transparency (ATT) prompt asks whether the Application may track you across apps and
          websites owned by other companies. If you allow tracking, the device advertising identifier (IDFA) may
          be used by AdMob to show you more relevant (personalized) ads. If you decline, you will still see ads,
          but they will not be personalized using the IDFA. On Android, ad personalization is governed by your
          device&apos;s advertising ID settings.
        </p>

        <h2 style={styles.heading}>Purchases</h2>
        <p style={styles.p}>
          In-app purchases and subscriptions are processed by Google Play Billing (on Android) or by Apple&apos;s
          App Store / StoreKit (on iOS). The Service Provider receives purchase status to unlock content, but does
          {' '}<strong>not</strong> receive or store your payment card details.
        </p>

        <h2 style={styles.heading}>Third Party Services</h2>
        <p style={styles.p}>
          The Application uses third-party services that may collect information used to identify you and that have
          their own privacy policies governing how they handle data. Links to the privacy policies of the third-party
          service providers used by the Application:
        </p>
        <ul style={styles.list}>
          <li><a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener noreferrer">Google Play Services</a></li>
          <li><a href="https://support.google.com/admob/answer/6128543?hl=en" target="_blank" rel="noopener noreferrer">Google AdMob</a> (advertising)</li>
          <li><a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">Google Firebase Analytics</a> (usage analytics)</li>
          <li><a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">Google Firebase Crashlytics</a> (crash reporting)</li>
          <li><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Play Billing</a> (purchases on Android)</li>
          <li><a href="https://www.apple.com/legal/privacy/" target="_blank" rel="noopener noreferrer">Apple App Store / StoreKit</a> (purchases on iOS)</li>
        </ul>

        <h2 style={styles.heading}>Third Party Access &amp; Disclosure</h2>
        <p style={styles.p}>
          Only aggregated, anonymized data is periodically transmitted to the external services above to help the
          Service Provider improve the Application. The Service Provider may disclose information:
        </p>
        <ul style={styles.list}>
          <li>as required by law, such as to comply with a subpoena or similar legal process;</li>
          <li>when they believe in good faith that disclosure is necessary to protect their rights, protect your safety or the safety of others, investigate fraud, or respond to a government request;</li>
          <li>with trusted service providers who work on their behalf, do not have independent use of the information disclosed to them, and have agreed to adhere to this privacy policy.</li>
        </ul>

        <h2 style={styles.heading}>Opt-Out Rights</h2>
        <p style={styles.p}>
          You can stop all collection of information by the Application by uninstalling it, using the standard
          uninstall process available on your device or app marketplace. You can also reset or limit ad
          personalization through your device&apos;s advertising ID settings. On iOS, you can withdraw tracking
          permission at any time in Settings &gt; Privacy &amp; Security &gt; Tracking.
        </p>

        <h2 style={styles.heading}>Data Retention Policy</h2>
        <p style={styles.p}>
          Wallpaper content and selected photos remain on your device until you delete them or uninstall the
          Application. The Service Provider retains aggregated usage data for as long as needed to operate the
          Application. To request deletion of data associated with you, contact
          {' '}<a href="mailto:palettexca@gmail.com">palettexca@gmail.com</a> and they will respond within a reasonable time.
        </p>

        <h2 style={styles.heading}>Children</h2>
        <p style={styles.p}>
          The Application does not address anyone under the age of 13. The Service Provider does not knowingly
          collect personally identifiable information from children under 13. If it is discovered that a child
          under 13 has provided personal information, the Service Provider will immediately delete it. If you are
          a parent or guardian and aware that your child has provided personal information, please contact
          {' '}<a href="mailto:palettexca@gmail.com">palettexca@gmail.com</a> so that the necessary actions can be taken.
        </p>

        <h2 style={styles.heading}>Security</h2>
        <p style={styles.p}>
          The Service Provider is concerned about safeguarding the confidentiality of your information and provides
          physical, electronic, and procedural safeguards to protect the information it processes and maintains.
        </p>

        <h2 style={styles.heading}>Changes</h2>
        <p style={styles.p}>
          This Privacy Policy may be updated from time to time. The Service Provider will notify you of any changes
          by updating this page with the new Privacy Policy and the effective date above. Continued use of the
          Application is deemed approval of all changes.
        </p>

        <h2 style={styles.heading}>Your Consent</h2>
        <p style={styles.p}>
          By using the Application, you consent to the processing of your information as set forth in this Privacy
          Policy now and as amended by the Service Provider.
        </p>

        <p style={styles.p}>
          Developer / Legal entity: Levi Liao (operating as &quot;PaletteX&quot;) <br />
        </p>

        <h2 style={styles.heading}>Contact Us</h2>
        <p style={styles.p}>
          If you have any questions regarding privacy while using the Application, or about these practices, please
          contact Levi Liao (PaletteX) at <a href="mailto:palettexca@gmail.com">palettexca@gmail.com</a>.
        </p>
      </div>
    </>
  )
}
